import {
  doGetQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { ENQUADRAMENTO_OPERACAO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    ENQUADRAMENTO_OPERACAO_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    ENQUADRAMENTO_OPERACAO_ENDPOINT,
    id
  ]);
}
